import React from "react";
import { Box, SvgIcon, Typography } from "@mui/material";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-coverflow"; // Corrected import path

import "./styles.css";

// Import required modules
import { Autoplay, Navigation, EffectCoverflow } from "swiper/modules";
import ToursCard from "./ToursCard";
import TourObjects from "./ToursObjects";
import { useIsMobile } from "../../../Hooks/useMedia";

export default function Tours() {
   const mobile = useIsMobile();
   return (
      <>
         <Swiper
            breakpoints={{
               300: {
                  slidesPerView: 1.3,
                  spaceBetween: 10, // Increased spacing for mobile
                  centeredSlides: true,
                  loop: true,
                  effect: "coverflow", // Enable coverflow effect
                  coverflowEffect: {
                     rotate: 0,
                     stretch: 0,
                     depth: 150,
                     modifier: 2,
                     slideShadows: false,
                  },
               },
               410: {
                  slidesPerView: 1.5,
                  spaceBetween: 20, // Increased spacing for small screens
                  centeredSlides: true,
                  loop: true,
                  effect: "coverflow", // Enable coverflow effect
                  coverflowEffect: {
                     rotate: 0,
                     stretch: 0,
                     depth: 150,
                     modifier: 2.5,
                     slideShadows: false,
                  },
               },
               600: {
                  slidesPerView: 2.4,
                  spaceBetween: 30, // Increased spacing for medium screens
                  centeredSlides: true,
                  loop: true,
                  effect: "coverflow", // Enable coverflow effect
                  coverflowEffect: {
                     rotate: 0,
                     stretch: 0,
                     depth: 100,
                     modifier: 2.5,
                     slideShadows: false,
                  },
               },
               768: {
                  slidesPerView: 2.5,
                  spaceBetween: 40, // Increased spacing for large screens
                  centeredSlides: true,
                  loop: true,
                  effect: "coverflow", // Enable coverflow effect
                  coverflowEffect: {
                     rotate: 0,
                     stretch: 20,
                     depth: 100,
                     modifier: 2.5,
                     slideShadows: false,
                  },
               },
               1024: {
                  slidesPerView: 3.25,
                  spaceBetween: 10, // Increased spacing for extra-large screens
                  centeredSlides: true,
                  loop: true,
                  effect: "coverflow", // Enable coverflow effect
                  coverflowEffect: {
                     rotate: 0,
                     stretch: 0,
                     depth: 100,
                     modifier: 2.5,
                     slideShadows: false,
                  },
               },
            }}
            centeredSlides={true}
            loop={true}
            effect="coverflow" // Enable coverflow effect
            coverflowEffect={{
               rotate: 0,
               stretch: 0,
               depth: 100,
               modifier: 2.5,
               slideShadows: false,
            }}
            autoplay={{
               delay: 1750,
               disableOnInteraction: false,
            }}
            navigation={{
               nextEl: ".swiper-button-next",
               prevEl: ".swiper-button-prev",
            }}
            modules={[Navigation, EffectCoverflow]} // Corrected module name
            style={{
               // marginTop: mobile ? -95 : -35,
               width: mobile ? "100%" : "90%",
               marginInline: "auto",
               paddingLeft: "20px",
            }}
         >
            {TourObjects.map((QualityObjects, index) => (
               <SwiperSlide key={index}>
                  <ToursCard
                     img={QualityObjects.img}
                     title={QualityObjects.title}
                     text={QualityObjects.text}
                  />
               </SwiperSlide>
            ))}
            {/* <Box className="swiper-button-next">
               <SvgIcon>
                  <ArrowForwardIcon />
               </SvgIcon>
            </Box>
            <Box className="swiper-button-prev">
               <SvgIcon>
                  <ArrowBackIcon />
               </SvgIcon>
            </Box> */}
         </Swiper>
      </>
   );
}
